// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import {createVuetify} from "vuetify";
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const customLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#F1F1F1',
    primary: '#2F6CB2',
    'primary-darken-1': '#3700B3',
    secondary: '#F27B35',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  }
}

export default createVuetify({
    icons:{
      defaultSet: 'mdi',
    aliases,
      sets: {
        mdi,
      },
    },
    theme: {
      // dark: true,
      // defaultTheme: "dark",
      defaultTheme: 'customLightTheme',
      themes: {
        customLightTheme
      },
    },
    components,
    directives,
  }
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
);
